// FAZ-10.6 / K-34 + K-39 — video embed URL çözümleyici. BE `ComponentVideoUrl.cs`
// aynası: yalnız YouTube/Vimeo allowlist'inden provider + güvenli videoId çıkarır.
// iframe HİÇBİR ZAMAN ham kullanıcı URL'inden kurulmaz — doğrulanmış id'den
// yeniden inşa edilir (youtube-nocookie / player.vimeo), böylece id embed URL'inden
// dışarı kaçamaz.

export type VideoProvider = 'youtube' | 'vimeo';

export interface VideoEmbed {
  provider: VideoProvider;
  videoId: string;
  /** Güvenli iframe src (doğrulanmış id'den kurulur). */
  embedUrl: string;
}

// BE regex'leri aynası.
const YT_WATCH = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([A-Za-z0-9_-]{6,20})(?:[&#].*)?$/;
const YT_SHORT = /^(?:https?:\/\/)?(?:www\.)?youtu\.be\/([A-Za-z0-9_-]{6,20})(?:[?#].*)?$/;
const YT_NOCOOKIE = /^(?:https?:\/\/)?(?:www\.)?youtube-nocookie\.com\/embed\/([A-Za-z0-9_-]{6,20})(?:[?#].*)?$/;
const VIMEO = /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/([0-9]{6,15})(?:[/?#].*)?$/;

/** Ham URL'i allowlist'e karşı dener; eşleşmezse null. */
export function parseVideoEmbed(url: string | null | undefined): VideoEmbed | null {
  if (!url || !url.trim()) return null;
  const value = url.trim();

  const yt = YT_WATCH.exec(value) ?? YT_SHORT.exec(value) ?? YT_NOCOOKIE.exec(value);
  if (yt?.[1]) {
    const videoId = yt[1];
    return {
      provider: 'youtube',
      videoId,
      embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}`,
    };
  }

  const vimeo = VIMEO.exec(value);
  if (vimeo?.[1]) {
    const videoId = vimeo[1];
    return {
      provider: 'vimeo',
      videoId,
      embedUrl: `https://player.vimeo.com/video/${videoId}`,
    };
  }

  return null;
}
